import { getLocaleCode, isJapaneseLocale } from './locale'
import { sortBy } from './sort'

export const isBaseVersion = (version) => version === '2024.0'
export const compareVersions = (a, b) => parseFloat(b) - parseFloat(a) // sort versions in descending order
export const getUrlVersionPart = (version) => (version && !isBaseVersion(version) ? `v${version}/` : '')

const isMultiVersion = (group) => group.length > 1 && new Set(group.map((g) => g.version)).size > 1

export const mapAllResources = (resources) => {
  const groupedResources = resources
    .reduce((acc, resource) => {
      if (!acc[resource.title]) {
        acc[resource.title] = [resource]
      } else {
        acc[resource.title].push(resource)
      }
      return acc
    }, {})

  const result = Object.values(groupedResources)
    .sort((a, b) => a[0].title.localeCompare(b[0].title, getLocaleCode())) // first sort by resource title
    .map((group) => (isMultiVersion(group) ? group
      .sort((a, b) => compareVersions(a.version, b.version)) // then sort by version descdending
      .map((resource) => ({
        ...resource,
        title: `${resource.title} v${resource.version}`,
      })) : group)).flat()

  if (isJapaneseLocale()) {
    return result.sort(sortBy('key'))
  }

  return result
}

export const mapTags = (tags) => {
  const groupedTags = tags
    .reduce((acc, tag) => {
      if (!acc[tag.name]) {
        acc[tag.name] = [tag]
      } else {
        acc[tag.name].push(tag)
      }
      return acc
    }, {})

  return Object.values(groupedTags)
    .sort((a, b) => a[0].name.localeCompare(b[0].name, getLocaleCode())) // first sort by resource title
    .map((group) => (isMultiVersion(group) ? group
      .sort((a, b) => compareVersions(a.version, b.version)) // then sort by version descdending
      .map((tag) => ({
        ...tag,
        withVersion: true,
      })) : group)).flat()
}

export const VERSION_INFO = 'version_info'
